import React from 'react';

export const BlogStyles: React.FC = () => (
  <style>{`
    .tox-tinymce-aux, .tox-pop, .tox-dialog, .tox-menu, .tox-toolbar, .tox-toolbar__overflow {
      z-index: 100000 !important;
    }
    .tox-tinymce {
      overflow: visible !important;
    }

    /* Контейнер для Container Queries */
    .blog-container-wrapper {
      container-type: inline-size;
      container-name: blogGrid;
      width: 100%;
    }

    /* Базовая сетка: 1 колонка (мобильный) */
    .blog-grid {
      display: grid;
      gap: 16px;
      grid-template-columns: 1fr;
      grid-auto-rows: minmax(280px, auto);
    }

    /* ≥ 550px → 2 колонки */
    @container blogGrid (min-width: 550px) {
      .blog-grid { grid-template-columns: repeat(2, 1fr); }
    }

    /* ≥ 800px → 3 колонки */
    @container blogGrid (min-width: 800px) {
      .blog-grid { grid-template-columns: repeat(3, 1fr); }
    }

    /* ≥ 1100px → 4 колонки */
    @container blogGrid (min-width: 1100px) {
      .blog-grid { grid-template-columns: repeat(4, 1fr); }
    }
  `}</style>
);